import { useDispatch, useSelector } from "react-redux";
import { selectNotesState, setNotesContent } from "../../../../../features/gms-proposal-forms/payment_term-loan_maturity-commission_services-notes-files/payment_term-loan_maturity-commission_services-notes-files.slice";
import RichTextEditor from "../../../../../library/ckeditor/ck-editor-text";

export default function ClientInputNotes() {

    const dispatch = useDispatch();
    const savedContent = useSelector(selectNotesState);

    return (
        <div className="overflow-hidden rounded bg-white shadow-sm">
            <div className="flex items-center justify-between border-b border-[#186cb2]/20 bg-[#186cb2]/10 px-4 py-3">
                <div>
                    <h2 className="text-sm font-semibold text-gray-800">
                        Notes
                    </h2>
                    <p className="text-xs text-gray-600">
                        Add notes or additional remarks if necessary.
                    </p>
                </div>
            </div>

            {/* {isEditing ? ( */}
                <div className="h-[400px] min-h-0 p-4">
                    <RichTextEditor
                        value={savedContent}
                        onChange={(e) => dispatch(setNotesContent(e))}
                    />
                </div>
            {/* ) : (
                <div className="p-4">
                    <RichTextViewer value={savedContent} />
                </div>
            )} */}
        </div>
    );
}